import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
    {
        q: "How much can I earn from Airbnb in Melbourne?",
        a: "Melbourne short-stay returns vary by suburb, property type and finish — but most owners we manage earn 30–60% more than they would from a traditional long-term lease. Use our income estimator on the home page or request a tailored forecast for a precise figure for your property.",
    },
    {
        q: "What does your management fee include?",
        a: "Our performance-based management fee covers everything: listing creation across all major platforms, dynamic pricing, 24/7 guest communication, guest vetting, calendar management, professional cleaning coordination, restocking, monthly reporting and review management. No setup or hidden fees.",
    },
    {
        q: "Do I need to furnish my property?",
        a: "No — our in-house styling team can take your property from empty shell to fully styled, photographed and listing-ready. We design every space to maximise nightly rate and guest reviews.",
    },
    {
        q: "How do you handle guest issues or emergencies?",
        a: "We provide 24/7 guest support and have local response partners across our service area. Any issue is triaged immediately and resolved without disturbing you. You're informed only when you need to be.",
    },
    {
        q: "Can I still use my property for personal stays?",
        a: "Absolutely. Block out any dates for personal use directly through your owner dashboard and we'll handle everything around it.",
    },
    {
        q: "What areas in Melbourne do you cover?",
        a: "Our focus is Melbourne's growing west — Werribee, Point Cook, Truganina, Tarneit, Hoppers Crossing, Melton, Caroline Springs — and the Geelong corridor (Geelong, Armstrong Creek, Ocean Grove, Torquay). We also take on exceptional properties across greater Melbourne — just get in touch.",
    },
];

export default function FAQSection() {
    return (
        <section className="py-28 md:py-40 bg-night" data-testid="faq-section">
            <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-16">
                <div className="lg:col-span-4">
                    <div className="eyebrow mb-4">FAQ</div>
                    <h2 className="headline text-4xl md:text-6xl mb-6 text-cream">
                        Frequently Asked<br />Questions
                    </h2>
                    <p className="text-cream/55 font-light max-w-md">
                        Considering hosting your property? Here are the questions
                        Melbourne owners ask us most often.
                    </p>
                </div>
                <div className="lg:col-span-8">
                    <Accordion type="single" collapsible className="w-full">
                        {FAQS.map((f, i) => (
                            <AccordionItem
                                key={i}
                                value={`item-${i}`}
                                data-testid={`faq-item-${i}`}
                                className="border-b border-line-dark py-2"
                            >
                                <AccordionTrigger className="text-left font-serif text-xl md:text-2xl text-cream hover:text-gold hover:no-underline py-6 [&>svg]:text-gold">
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="text-cream/55 font-light leading-relaxed text-base pb-6">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </div>
            </div>
        </section>
    );
}
